import React from 'react';

import type { RouteMatch } from '@confluence/route';
import { ForgeFullPageExtensionPoint } from '@confluence/forge-ui/entry-points/FullPage';

import { fg } from '@atlaskit/platform-feature-flags';
import Box from '@atlaskit/primitives/box';
import SectionMessage from '@atlaskit/section-message/section-message';

export const FullPageForgeAppsRoute = ({ params: { appId, envId } }: RouteMatch) =>
	fg('forge-confluence-full-page-app-ui-eap-enabled') ? (
		<ForgeFullPageExtensionPoint appId={appId} envId={envId} />
	) : (
		<Box>
			<SectionMessage appearance="error">Error: This module is not found.</SectionMessage>
		</Box>
	);

FullPageForgeAppsRoute.NAVIGATION_PARAMS = ({ params: { appId, envId } }: RouteMatch) => {
	return false;
};
